<template>
    <div v-if="isElectron && updateProgress > 0 && updateProgress < 100" class="update-progress">
        <h3>Downloading Update: {{ updateProgress }}%</h3>
        <progress :value="updateProgress" max="100"></progress>
    </div>
</template>

<script>
export default {
    name: 'AppUpdater',
    data() {
        return {
            isElectron: false,
            updateProgress: 0,
        };
    },
    mounted() {
        // Check if running in Electron by looking for electronAPI
        this.isElectron = !!window.electronAPI;
        
        if (this.isElectron && window.electronAPI.onUpdateProgress) {
            // Register the progress listener
            window.electronAPI.onUpdateProgress((percent) => {
                this.updateProgress = percent;
            });
        }
    },
};
</script>

<style scoped>
.update-progress {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: #f0f0f0;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

progress {
    width: 200px;
}
</style>